export const ROLES_KEY    = "06d6f85c05ee5aff58c5b24976e5cf33092392989ebbe11236667c6d7afe5f80";
export const TOKEN_KEY    = "7586bf4da0b4a25e8783ef108cf2270b4447888ba7aedb6050f0436b3c3d0153";
export const USERINFO_KEY = "d70f47790f689414789eeff231703429c7f88a10210775906460edbf38589d90"

//RUOLI
export const ADMINISTRATOR_IS_ID        = "95b0b3ab179332490c229e0ae8c22fe2703bacb28d32ca80a28e02c2820e1d94";
export const ADMINISTRATOR_IS_NOME      = "Amministratore IS";

export const ADMINISTRATOR_HOLDING_ID   = "12b74feef88433eff5ef0290374cd7c3fae8fedab6aaff94d765c10af575ff33";
export const ADMINISTRATOR_HOLDING_NOME = "Amministratore Holding";

export const ADMINISTRATOR_AZIENDA_ID   = "06d6f85c05ee5aff58c5b24976e5cf33092392989ebbe11236667c6d7afe5f80";
export const ADMINISTRATOR_AZIENDA_NOME = "Amministratore Azienda";

export const OPERATOR_ID                = "85d608343113a838313d723cab6df2184b4d5870909b9a9c224580f1af9211cb";
export const OPERATOR_NOME              = "Operatore";

export const ACCOUNT_FREE_ID            = '253387e8620ee1896c76809782406e139bce35860aaa0d61991965319ba0dc32';
export const ACCOUNT_FREE_NOME          = 'Utente Free';

export const ACCOUNT_PRO_ID            = '7f9ed89c7297f99669b6e79d9d8d404d19f160ca40b40f42896506fa7942786b';
export const ACCOUNT_PRO_NOME          = 'Utente Pro';



// WEBPACK FOOTER //
// ./src/Utils/Roles_Types.js